import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { I18nProvider } from "../../shared/i18n";
import { theme } from "../../shared/ui/theme";
import { App } from "./App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, retry: 1 } },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

// Google ile Giriş — VITE_GOOGLE_CLIENT_ID boşsa provider sarmalı atlanır
// (Google butonu CustomerAuth'ta zaten gizli); e-posta OTP çalışmaya devam.
const googleClientId = import.meta.env["VITE_GOOGLE_CLIENT_ID"] || "";

const tree = (
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-center" />
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          <App />
        </I18nProvider>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>
);

createRoot(rootEl).render(
  googleClientId
    ? <GoogleOAuthProvider clientId={googleClientId} locale="tr">{tree}</GoogleOAuthProvider>
    : tree,
);
